import * as actionTypes from '@store/actions/actionTypes';
import CreateEvent from '@src/createEvent';

const initialState = {
  token: null,
  data: {},
  mail: null,
  error: null,
  loading: false
};
const reducer = (state = initialState, action) => {
  const event = new CreateEvent('quote-reload');
  switch (action.type) {
    case actionTypes.AUTH_START:
      return {
        ...state,
        error: null,
        loading: true
      };
    case actionTypes.AUTH_SUCCESS:
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 500);
      return {
        ...state,
        error: null,
        loading: false,
        token: action.authData.token,
        mail: action.authData.mail,
        data: action.authData.data
      };
    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case actionTypes.AUTH_LOGOUT:
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 500);
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js